import { Grid, Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';

function BorderCard({ children }: React.PropsWithChildren<unknown>) {
  return (
    <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
      {children}
    </Card>
  );
}

export function PopularEstatePlanningStrategies() {
  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <BorderCard>
          <Stack spacing={2}>
            <EditableRegion regionId="lifetime-gifting" />
          </Stack>
        </BorderCard>
      </Grid>

      <Grid item sm={6}>
        <BorderCard>
          <Stack spacing={2}>
            <EditableRegion regionId="irrevocable-trusts" />
          </Stack>
        </BorderCard>
      </Grid>

      <Grid item sm={6}>
        <BorderCard>
          <Stack spacing={2}>
            <EditableRegion regionId="medical-payments" />
          </Stack>
        </BorderCard>
      </Grid>

      <Grid item sm={6}>
        <BorderCard>
          <Stack spacing={2}>
            <EditableRegion regionId="gst-planning" />
          </Stack>
        </BorderCard>
      </Grid>
    </Grid>
  );
}
